import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

/* BOOTSTRAP */
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
/* FINE BOOTSTRAP */

/* Vue-MQ */
import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 768,
        md: 992,
        lg: Infinity,
    }
});
/* FINE Vue-MQ */

/* Google Maps API */
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAyi_q77r31RUFX9ap8H1VhN1iugiPL3hA',
        v: '3.26',
    }
});
/* Fine Google Maps API */


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');